// frontend/src/SettingsSidebar.js
import React from 'react';

// Removed axios import as it's not used here anymore

// Use CSS classes defined in SettingsPage.css instead of inline styles
const SettingsSidebar = ({ activeTab, setActiveTab, handleSelectPipeline, pipelines = [], selectedPipeline }) => {
    // Pipelines are now passed directly as props

    return (
        <div className="settings-sidebar"> {/* Use class */}
            {/* Tab Selection Buttons */}
            {['Main', 'Prompts', 'Prompt Pipelines', 'Data Upload', 'Other Settings'].map((tab) => (
                <button
                    key={tab}
                    // Use CSS classes for styling
                    className={`sidebar-button ${activeTab === tab ? 'active' : ''}`}
                    onClick={() => setActiveTab(tab)}
                >
                    {tab}
                </button>
            ))}

            {/* Conditional Pipeline Selection Dropdown */}
            {activeTab === 'Prompt Pipelines' && (
                <div className="pipeline-select-section"> {/* Use class */}
                    <h4 className="sidebar-heading"> {/* Use class */}
                        Select Pipeline to Edit
                    </h4>
                    <select
                         onChange={handleSelectPipeline}
                         value={selectedPipeline?.id || ''} // Use selectedPipeline object's ID
                         className="pipeline-select-dropdown" // Use class
                     >
                        <option value="">-- Select a pipeline --</option>
                         {/* Ensure pipelines is an array before mapping */}
                         {Array.isArray(pipelines) && pipelines.slice().sort((a,b)=> a.name.localeCompare(b.name)).map(pipeline => ( // Sort alphabetically
                            <option key={pipeline.id} value={pipeline.id}>
                                {pipeline.name}
                            </option>
                        ))}
                    </select>
                     {/* Display message if no pipelines exist */}
                     {(!Array.isArray(pipelines) || pipelines.length === 0) && (
                        <small style={{display: 'block', marginTop: '8px', color: 'var(--secondary-color)'}}>No pipelines found.</small>
                     )}
                </div>
            )}
        </div>
    );
};

export default SettingsSidebar;
